import { render, staticRenderFns } from "./AssociadoCotas.vue?vue&type=template&id=73fcf666&scoped=true&"
import script from "./AssociadoCotas.vue?vue&type=script&lang=js&"
export * from "./AssociadoCotas.vue?vue&type=script&lang=js&"
import style0 from "./AssociadoCotas.vue?vue&type=style&index=0&id=73fcf666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fcf666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VEditDialog,VIcon,VRow,VSubheader,VTextField})
